import React from 'react';
import { Plus } from 'lucide-react';
import { ACCENT_SPECS } from '../../lib/rcu/catalog/accent';
import { LOAD_ICON_MAP } from '../../lib/rcu/catalog/icon';
import { LOAD_TYPE_SPECS } from '../../lib/rcu/catalog/loadType';
import type { ChannelTarget } from '../../lib/rcu/query/targets';

export interface ChannelTileProps {
  target: ChannelTarget;
  onSelect: (target: ChannelTarget) => void;
}

/**
 * One physical output. Filled when a load is wired to it, dashed when free —
 * the whole grid is the technician's map of the hardware.
 */
export const ChannelTile: React.FC<ChannelTileProps> = ({ target, onSelect }) => {
  const accent = ACCENT_SPECS[target.accent];
  const load = target.load;

  if (load === undefined) {
    return (
      <button
        type="button"
        onClick={() => onSelect(target)}
        className="flex min-h-[92px] w-full flex-col justify-between rounded-2xl border border-dashed border-[#E0E0E0] bg-white/60 px-4 py-3 text-left transition-colors hover:border-[#D4A054] hover:bg-[#FDF6E9]"
      >
        <span className="text-xs font-medium uppercase tracking-wide text-[#999999]">
          {target.shortLabel}
        </span>
        <span className="flex items-center gap-1.5 text-sm text-[#666666]">
          <Plus className="h-3.5 w-3.5" />
          Free · {target.outputHint}
        </span>
      </button>
    );
  }

  const Icon = LOAD_ICON_MAP[load.iconKey];

  return (
    <button
      type="button"
      onClick={() => onSelect(target)}
      className={`flex min-h-[92px] w-full flex-col justify-between rounded-2xl border px-4 py-3 text-left transition-colors ${accent.tile} ${accent.border}`}
    >
      <span className={`text-xs font-medium uppercase tracking-wide ${accent.text}`}>
        {target.shortLabel}
      </span>
      <span className="flex items-center gap-2">
        <Icon className={`h-4 w-4 shrink-0 ${accent.text}`} />
        <span className="min-w-0">
          <span className="block truncate text-sm font-medium text-[#333333]">{load.name}</span>
          <span className="block text-xs text-[#666666]">
            {LOAD_TYPE_SPECS[load.type].label}
          </span>
        </span>
      </span>
    </button>
  );
};

export default ChannelTile;
